module.exports = __webpack_public_path__ + "img/triangles.41437d66.jpeg";